import { createActions, handleActions } from 'redux-actions';

import { CONSTS } from '../common/consts/Consts';

// アクションタイプの接頭辞
const PREFIX = CONSTS.COMMON_ACTION_PREFIX + 'home';

export const TYPES = {
  SET_PERMISSION: PREFIX + 'SetPermission',
  SET_HOME_DATA: PREFIX + 'SetHomeData',
};

//値はメニューのfidを設定すること
export const PERMISSION_KEY = {
  NOTICE_HISTORY: 'notice_history',
  NOTICE_REGISTER: 'notice_register',
  GROUPHISAI_SEARCH: 'grouphisai_search',
  GROUPHISAI_REGISTER: 'grouphisai_register',
};

export const HOME_DATA_KEY = {
  NOTICE_LATEST_DATA: 'NOTICE_LATEST_DATA',
  GROUPHISAI_DATA: 'GROUPHISAI_DATA',
  GROUPHISAI_KBN_DATA: 'GROUPHISAI_KBN_DATA',
  GROUPHISAI_KBN_SELECT_DATA: 'GROUPHISAI_KBN_SELECT_DATA',
  USER_INFO_DATA: 'USER_INFO_DATA',
};

export const INIT_STATE = {
  permission: {},
  homeData: {
    //[key]: data
  },
};

export const homeActions = createActions({
  [TYPES.SET_PERMISSION]: (...args) => {
    return {
      permission: args[0],
    };
  },
  [TYPES.SET_HOME_DATA]: (...args) => {
    return {
      key: args[0],
      data: args[1],
    };
  },
});

export const homeReducer = handleActions(
  {
    [TYPES.SET_PERMISSION]: (state, action) => {
      return {
        ...state,
        permission: action.payload.permission,
      };
    },
    [TYPES.SET_HOME_DATA]: (state, action) => {
      return {
        ...state,
        homeData: { ...state.homeData, [action.payload.key]: action.payload.data },
      };
    },
  },
  INIT_STATE,
);
